'use client';

import { type RefObject, useEffect, useState } from 'react';

export const useHasImgLoaded = ($img: RefObject<HTMLImageElement | null>, bypass?: boolean) => {
  const [hasLoaded, setHasLoaded] = useState<boolean>(true);

  const isComplete = $img?.current?.complete;
  const height = $img?.current?.naturalHeight;

  useEffect(() => {
    const hasHeight = (height ?? 0) !== 0;
    // Source - https://stackoverflow.com/a/23522755
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isComplete && hasHeight) {
      setHasLoaded(true);
    } else if (!isSafari && !bypass) {
      setHasLoaded(false);
    }
  }, [isComplete, height]);

  return {
    hasLoaded,
    imgOnLoad: () => setHasLoaded(true),
  };
};
